module.exports = __webpack_public_path__ + "static/media/HelveticaNeueBold.7f281199.ttf";